import type { FaireProductEntity } from "../../entity_types/product";

export const p_yscejvfrrx: FaireProductEntity = {
  token: "p_yscejvfrrx",
  type: "product",
  name: "STRIPED KNIT TANK AND PANTS / WL25-12077",
  brandToken: "b_1hsvo6fo88",
  brandName: "Wishlist Apparel",
  imageUrl: "https://cdn.faire.com/fastly/2c28f1ccface05853a7f59b464437c2f6829ea4f416cdaaada1d62013fefd438.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5c7aae5572b08a23f4ef71ca65b04f2bf37fa7b98c44968d7732bd43df7c44e1.jpeg",
    "https://cdn.faire.com/fastly/1e08359b8b27bfda45cf1888b94ba54579809175761190403bae84f22bc62648.jpeg",
    "https://cdn.faire.com/fastly/5c2d0aacd009eaa880c86a53150e41a13fe91da6f7b18808fd899379e2716831.jpeg"
  ],
  priceDollars: 241.5,
  description: "STRIPED KNIT TANK AND PANTS\n- BOTTOM: ELASTIC WAISTBAND, SIDE POCKETS\n- SLEEVELESS, ROUND NECK, FULL LENGTH, EASY, COMFY, RELAXED, CASUAL, EVERYDAY, SUMMER, SPRING\n\nSMALL: INSEAM LENGTH - 27 1/4\"\nMODEL IS WEARING SIZE SMALL.\n\nSELF: 69% COTTON, 29% POLYESTER, 2% SPANDEX\nCONTRAST: 60.3% POLYESTER, 36.5% COTTON, 3.2% SPANDEX\n\n* Due to lighting and differences in monitors, actual colors may vary slightly from what appears online.",
  tags: [],
  msrpDollars: 483,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:26.630Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
